<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('expenseAccount', 1) })"
    :value="value"
    :field-value.sync="expenseAccount.name"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      expenseAccount: {
        name: ''
      },
      edit: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.expenseAccount =
            this.toEdit !== null ? { ...this.toEdit } : { name: '' }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          let account = !this.edit
            ? await this.$api.expense.account.create({
                form: this.expenseAccount
              })
            : await this.$api.expense.account.edit({
                pk: this.expenseAccount.pk,
                form: this.expenseAccount
              })
          this.$emit('done', account.data)
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('expenseAccount', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
